<template>
    <div id="downLoadApp">
        <div class="downLoad_container">
            <div class="logo_container">
                <div class="logo_wrapper">
                    <section>
                        <img src="../../../static/wap_images/logo.png" alt="wap_logo">

                    </section>
                    <div class="dn_btn" @click="getUserAgent">
                        <span>立即下载</span>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import Swiper from 'swiper';
    export default {
        name: "downLoadApp",
        data(){
            return{
                Agents:["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"]
            }
        },
        methods:{
            //判断机型
            getUserAgent(){
                var u = navigator.userAgent, app = navigator.appVersion;
                var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
                var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
                if (isAndroid) {
                    window.open('https://download.weijieyao.com/weijieyao_android_setup.apk')
                }
                if (isIOS) {
                    window.open('https://app.weijieyao.com/mum/web/h5/download/index.html')
                }
            }
        },
        mounted(){

        }
    }
</script>

<style scoped lang="scss">
    #downLoadApp{
        width: 100%;
        .downLoad_container{
            width: 100%;
            margin: 0 auto;
            >.logo_container{
                background: #fff;
                padding: .14rem  0;
                .logo_wrapper{
                    width: 90%;
                    margin: 0 auto;
                    overflow: hidden;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    >section{
                        width: 1.5rem;
                        position: relative;
                        p{
                            font-size: .12rem;
                            position: absolute;
                            right: .05rem;
                            transform: translateY(-100%);
                        }
                        img{
                            width: 1.07rem;
                            height: 0.45rem;
                        }
                    }
                    >.dn_btn{
                        width: .8rem;
                        height: .33rem;
                        background: #15b2b2;
                        color: #fff;
                        text-align: center;
                        line-height: .33rem;
                        font-size: .14rem;
                        border-radius: .4rem;
                    }
                }



            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/common/downLoadApp.vue